// extracted by mini-css-extract-plugin
export default {"container":"HeatMap_container__TBeKz","tvcontainer":"HeatMap_tvcontainer__NQGZ5"};